import {isBrowser} from "../app/read_rp_environment_variables";
import {RpStore} from "../store/store";
import {createInitAgencyScript} from "./create_init_agency_script";

/**
 * DOCS:
 * Tagging - https://support.smartadserver.com/s/article/Tagging-guide
 * Targeting: https://help.smartadserver.com/s/article/Using-keyword-targeting
 */

export interface ISmartAdServerConfig {
    siteId: number;
    pageId: number;
    // formatId: string;
    formats: {id: number}[];
    target: string;
}

let isSmartAdServerInitialized = false;

export const initSmartAdServer = (config: ISmartAdServerConfig, refresh: boolean, store: RpStore | null) => {
    // initialize only in browser
    if (!isBrowser) {
        return;
    }

    // initialize only once
    if (isSmartAdServerInitialized) {
        return;
    }

    const initAgencyScript = createInitAgencyScript(store);

    // fetch/init W2T
    const firstScriptElem = document.getElementsByTagName("script")[0];
    const newScriptElem = document.createElement("script");
    newScriptElem.async = true;
    newScriptElem.src = "//ced.sascdn.com/tag/2907/smart.js";
    firstScriptElem.parentNode && firstScriptElem.parentNode.insertBefore(newScriptElem, firstScriptElem);

    // snippet
    const win = window as any; // eslint-disable-line @typescript-eslint/no-explicit-any
    win.sas = win.sas || {};
    win.sas.cmd = win.sas.cmd || [];
    win.sas.cmd.push(function () {
        // win.sas.setup({networkid: 2907, domain: "//www14.smartadserver.com", async: true});
        win.sas.setup({networkid: 2907, domain: "https://www14.smartadserver.com", async: true});
    });
    win.pgAds = {init: initAgencyScript};
    isSmartAdServerInitialized = true;

    // configure
    win.sas.cmd.push(function () {
        if (refresh) {
            win.sas.refresh({target: config.target});
        } else {
            win.sas.call("onecall", config);
        }
    });
};
